abstract class Component {
    abstract cleanup() : void
}

export default Component;